import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// View Current Stock (legacy /Reports/ItemStockReport, menu MOID 294).
// Params go through axios `params` so codes with '&' / '/' are encoded.

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// 1. Store CCs of the user (spGetCCsforitemcode) → [{ CCID, CCVAL }], first row is { CCID: 'SelectAll' }
export const getStockCostCenterCodes = async ({ UID, RID }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetStockCostCenterCodes`, { params: { UID, RID }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// 2. Item categories (spGetItemCategoryDetailsStock) → [{ Categoryid, CategoryValue }], incl. { Categoryid: '0', 'Select All' }
export const getStockCategories = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/Getcategoriesstock`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// 3. Item code autocomplete (spGetAutoCompleteitemcode) → [{ SearchItem: 'CODE , NAME | SPEC' }]
export const getItemCodeAutoComplete = async ({ Pfx, Cat }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/GetAutoCompleteitemcode`, { params: { Pfx, Cat }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// 4. Stock grid (spGetViewItemsDetail). ItemText is only used when CCode = 'SelectAll'; sent empty otherwise
// (the action's string params are required for route matching, so it must always be present).
export const getViewItemsGrid = async ({ CCode, Cat, ItemText, UID, RID }) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Purchase/ViewItemsGrid`, {
            params: { CCode, Cat, ItemText: ItemText || '', UID, RID }, headers,
        });
        return response.data;
    } catch (error) { return handle(error); }
};
